export interface ArticleAudioSource {
  audioSeconds?: number;
  chapter?: {
    audioSeconds?: number;
    videoSeconds?: number;
    duration?: string;
  };
}

export function readAudioSeconds(response: ArticleAudioSource): number {
  return response.audioSeconds ?? response.chapter?.audioSeconds ?? parseDurationSeconds(response.chapter?.duration);
}

export function readVideoSeconds(response: ArticleAudioSource): number {
  return response.chapter?.videoSeconds ?? parseDurationSeconds(response.chapter?.duration);
}

function parseDurationSeconds(value: string | undefined): number {
  if (!value) return 0;
  const h = value.match(/(\d+(?:\.\d+)?)\s*h/i);
  const m = value.match(/(\d+(?:\.\d+)?)\s*m/i);
  const s = value.match(/(\d+(?:\.\d+)?)\s*s/i);
  if (h || m || s) return Math.round((h ? Number(h[1]) * 3600 : 0) + (m ? Number(m[1]) * 60 : 0) + (s ? Number(s[1]) : 0));
  const colon = value.match(/^(\d{1,2}):(\d{2})$/);
  if (colon) return Number(colon[1]) * 60 + Number(colon[2]);
  const n = value.match(/\d+(?:\.\d+)?/);
  return n ? Math.round(Number(n[0]) * 60) : 0;
}
